import type { Bike } from "@/types/bike";

type ProductIdentity = Pick<Bike, "brand_display" | "title">;

function normalized(value: string) {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/** Return one product name even when Shopify already prefixes the brand. */
export function productName(bike: ProductIdentity) {
  const brand = bike.brand_display.trim();
  const title = bike.title.trim();

  if (!brand || normalized(title).startsWith(normalized(brand))) return title;
  return `${brand} ${title}`;
}
